import React from 'react';
import { InputList, InputListProps } from 'framework/form';

const ExpectedCompensationListInput: React.FC<InputListProps> = ({ inputTemplate, ...props }) => {
  return <InputList {...props} maxFields={10} inputTemplate={inputTemplate} />;
};

export default ExpectedCompensationListInput;
